import { IViewport } from "@config/appConfig";
import { AppAction, IAppAction } from "@misc/Action";
import { store } from "@misc/Reducer";
import { IAppState } from "@misc/State";
import Config from "@service/Config";
import { FC } from "react";
import { useSelector } from "react-redux";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import ToastMessage from "./ToastMessage";

interface IToastsprops { }

const Toasts: FC<IToastsprops> = () => {
    const { small } = Config.get<IViewport>("viewport");
    const { toasts, width } = useSelector((state: IAppState) => ({
        toasts: state.toasts,
        width: state.windowWidth
    }));

    const removeToast = (code: string) => {
        toasts.splice(toasts.findIndex(t => t.code === code), 1);
        store.dispatch<IAppAction>({ type: AppAction.Toasts, payload: { toasts } });
    }

    return (
        <TransitionGroup className="toasts">
            {
                toasts.map((t, index) =>
                    <CSSTransition
                        key={index}
                        classNames={width > small ? "toasts-slide-side" : "toasts-slide-up"}
                        timeout={500}
                    >
                        <ToastMessage
                            key={index}
                            toast={t}
                            removeToast={removeToast}
                        />
                    </CSSTransition>
                )
            }
        </TransitionGroup>
    );
};

export default Toasts;
